export default "__VITE_ASSET__uSZS6XlJ__"